import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './Policies.css';

const Policies = () => {
  const policies = [
    {
      name: 'Fair Practice Code',
      path: '/Fair-Practice-Code-English.docx',
      icon: '📄'
    },
    {
      name: 'Grievance Redressal Policy',
      path: '/Grievance%20Redressal%20Policy.docx',
      icon: '📄'
    },
    {
      name: 'Interest Rate Policy',
      path: '/Interest%20Rate%20Policy.docx',
      icon: '📄'
    }
  ];

  return (
    <div className="policies-page">
      {/* Banner Section */}
      <section className="policies-banner">
        <div className="policies-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">POLICIES</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policies-content">
        <div className="policies-wrapper">
          <div className="policies-list">
            {policies.map((policy, index) => (
              <a
                key={index}
                href={policy.path}
                target="_blank"
                rel="noopener noreferrer"
                className="policy-item policy-cta"
              >
                <div className="policy-icon">{policy.icon}</div>
                <div className="policy-name">{policy.name}</div>
                <div className="policy-arrow">↗</div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;




